module.exports = __webpack_public_path__ + "media/images/gallery/6-754d7de99514d2196aa6796368918775.jpg";